
import * as React from 'react';
import { GridCustomCellProps } from '@progress/kendo-react-grid';
import ActionPopup from './ActionPopup';
import { OpenShipment } from '.';

export default function MyCommandCell(
  reserve?: (shipment: OpenShipment) => void,
  release?: (shipment: OpenShipment) => void,
  decline?: (shipment: OpenShipment) => void) {
  return class extends React.Component<GridCustomCellProps> {
    render() {
      return <td {...this.props.tdProps}><ActionPopup
        dataItem={this.props.dataItem}
        reserve={reserve}
        release={release}
        decline={decline}
      /></td>
    }
  }
};
